<template>
  <!-- <div>
    <div
      style="width: 10cm;
      height: 9.8cm;
      padding:30px 5px 0;
      box-sizing: border-box;
      border:1px solid"
      v-if="listData"
      ref="container"
    >
      <div
        style="display:flex;justify-content: space-between; align-items: center;"
      >
        <div>{{ listData.airway_number }}</div>
        <div>{{ listData.cn_name }}</div>
        <div>共 {{ listData.total_num }} 件</div>
      </div>
      <div>{{ listData.warehouse_no }}</div>
      <div>
        Winteam Technology Development CO.,Limited F202 No. 228, Yuncheng West
        Road, Yuncheng Street,Baiyun District, Guangzhou,CHINA
      </div>
      <div
        style="display:flex;justify-content: space-between; align-items: center;"
      >
        <div style="width:180px">Product name:</div>
        <div style="width:100px">Model:</div>
        <div style="width:100px">Quantity:</div>
        <div style="width:100px">Trademark:</div>
      </div>
      <div
        style="display:flex;justify-content: space-between; align-items: center;"
      >
        <div style="width:180px">Viewfinder Eyecup</div>
        <div style="width:100px">Model</div>
        <div style="width:100px">Quantity</div>
        <div style="width:100px">Trademark</div>
      </div>
    </div>
  </div> -->
</template>

<script>
import getLodop from "@/utils/lodop";
export default {
  name: "print",
  props: {
    printData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    printData(val) {
      // this.listData = {};
      // val.forEach(el => {
      //   this.listData = el;
      // });
      this.$nextTick(() => {
        this.print();
      });
    },
  },
  data() {
    return {
      size: 20,
      listData: null,
      company: "",
    };
  },
  methods: {
    print() {
      // return false;
      let lodop = getLodop(this);
      if (!lodop) {
        return false;
      }
      // lodop.PRINT_INIT(this.company + "索赔函"); //首先一个初始化语句
      lodop.SET_PRINT_PAGESIZE(1, "104mm", "100mm", ""); //规定纸张大小；使用A4纸
      lodop.SET_PRINT_STYLEA(0, "AlignJustify", false); //ItemType:设置上面的为页眉页脚，每页固定位置输出
      this.printData.forEach((item, index) => {
        lodop.SET_PRINT_STYLE("Bold", 0);
        lodop.SET_PRINT_STYLE("FontSize", 10);
        this.listData = item;
        let addhtml = "";
        let cn_name = "";
        let en_name = "";
        if (item.child && item.child.length > 0) {
          addhtml += `<div
              style="margin-top:5px;margin-bottom:5px"
            >
              <span style="width:140px;display:inline-block">Product name:</span>
              <span style="width:60px;display:inline-block">Model:</span>
              <span style="width:70px;display:inline-block">Quantity:</span>
              <span style="width:70px;display:inline-block">Trademark:</span>
            </div>
          `;
          item.child.forEach((it, idx) => {
            cn_name += (cn_name ? "+" : "") + it.cn_name;
            en_name += (en_name ? "+" : "") + it.en_name;
            addhtml += `
            <div
              style="margin-bottom:5px"
            >
              <span style="width:140px;display:inline-block">${it.clearance_name}</span>
              <span style="width:60px;display:inline-block">${it.model_no}</span>
              <span style="width:70px;display:inline-block">${it.box_num} <span >   PCS</span></span>
              <span style="width:70px;display:inline-block">${it.trademark}</span>
            </div>
            `;
            if (idx == item.child.length - 1) {
              if (item.tableware == "是" && (cn_name.indexOf("空气炸锅") < 0 || cn_name.indexOf("热风梳") > -1 || en_name.indexOf("Hair Styler") > -1)) {
                addhtml += `
                  <div style="width:40px;position: absolute;right: 20px;bottom: 10px;">
                    <img style="width:100%"  src="${this.$globalUrl}/img/tableware.png" />
                  </div>
                </div>
                `;
              } else if (cn_name.indexOf("空气炸锅") > -1 || cn_name.indexOf("热风梳") > -1 || en_name.indexOf("Hair Styler") > -1) {
                addhtml += `
                  <div style="width:70px;position: absolute;right: 5px;bottom:10px;">
                    <img style="width:100%"  src="${this.$globalUrl}/img/air_fryer.png" />
                  </div>
                </div>
                `;
              } else {
                addhtml += `</div>`;
              }
            }
          });
        } else {
          cn_name = item.cn_name;
          en_name = item.en_name;
					
          addhtml += `
            <div
              style="display:flex;justify-content: space-between; align-items: center;margin-top:5px;position: relative;"
            >
              <div>
                <div style="display:flex;margin-bottom:5px">
                  <span style="width:130px">Product name:</span>
									<span style="margin-left:20px">${item.clearance_name}</span>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <span style="width:130px">Model:</span>
                  <span style="margin-left:20px">${item.model_no}</span>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <span style="width:130px">Quantity:</span>
                  <span style="margin-left:20px;width:100px">${
                    item.box_num
                  }</span>
                  <span > PCS</span>
                </div>
                <div style="display:flex;margin-bottom:5px">
                  <span style="width:130px">Trademark:</span>
                  <span style="margin-left:20px">${item.trademark}</span>
                </div>
              </div>
              <div style="margin-right:20px; width:40px;display:${
                item.tableware == "是" && (cn_name.indexOf("空气炸锅") < 0 || cn_name.indexOf("热风梳") > -1 || en_name.indexOf("Hair Styler") > -1)
                  ? "inline-block"
                  : "none"
              }">
                <img style="width:100%"  src="${
                  this.$globalUrl
                }/img/tableware.png" />
              </div>
              <div style="margin-right:5px; width:100px;display:${
                cn_name.indexOf("空气炸锅") > -1 || cn_name.indexOf("热风梳") > -1 || en_name.indexOf("Hair Styler") > -1 ? "inline-block" : "none"
              }">
                <img style="width:100%"  src="${
                  this.$globalUrl
                }/img/air_fryer.png" />
              </div>
            </div>
          </div>
          `;
        }
        let html =
          `
          <div
            style="width: 10cm;
            height: 9.8cm;
            padding:10px 10px 0;
            box-sizing: border-box;"
          >
            <div
              style="display:flex;justify-content: space-between; align-items: flex-start;margin-bottom:5px"
            >
              <div style="font-size:18px;font-weight:bold;line-height: 18px;">
                <div style="display:flex">
									<span style="width:140px">${item.airway_number}</span>
									<span style=""> ${item.box_no}</span>
								</div>
                <div style="font-size:18px;line-height: 20px;white-space: nowrap;">${cn_name}</div>
              </div>
            </div>
            <div>
              Winteam Technology Development CO.,Limited F202 No. 228, Yuncheng West
              Road, Yuncheng Street,Baiyun District, Guangzhou,CHINA
            </div>
          ` + addhtml;
        lodop.ADD_PRINT_HTM(0, 0, "100mm", "100mm", html);
        lodop.SET_PRINT_STYLE("Alignment", 2);
        if(item.barcode)lodop.ADD_PRINT_BARCODE(
          "68mm",
          "12mm",
          "80mm",
          "20mm",
          "128Auto",
          item.barcode
        );
        lodop.SET_PRINT_STYLE("Bold", 1);
        lodop.SET_PRINT_STYLE("FontSize", 20);
        lodop.ADD_PRINT_TEXT("90mm", "10mm", "80mm", "20mm", "MADE IN CHINA");
        if (index != this.printData.length - 1) {
          lodop.NEWPAGE();
        }
      });
      lodop.PREVIEW(); //打印预览
    },
  },
};
</script>

<style lang="less" scoped>
.border {
  border: 1px solid;
}
.center {
  text-align: center;
}
.page {
  width: 21cm;
  min-height: 29.7cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  position: relative;
}

@page {
  size: A4;
  margin: 0;
}
@media print {
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }
}
table {
  border-collapse: collapse; /*去掉双重的border*/
  width: 20cm;
  height: 28.7cm;
  font-size: 14px;
  text-align: center;
}
table tr td:nth-child(1) {
  /* width: auto; */
  width: 20%;
}
table tr td {
  padding: 10px 0;
}
</style>
